import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConstantsService } from './api-constants.service';
import {
  Payment,
  PaymentCheckout,
  PaymentCheckoutParams
} from '~core/models/payment.models';
import { Observable } from 'rxjs';
import { Pagination } from '~core/models/core.models';

@Injectable()
export class PaymentsService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  list(): Observable<Pagination<PaymentCheckout>> {
    return this._httpClient.get<Pagination<PaymentCheckout>>(
      `${this._apiConstantsService.paymentsUrl}`
    );
  }

  read(paymentId: string): Observable<Payment> {
    return this._httpClient.get<Payment>(
      `${this._apiConstantsService.paymentsUrl}/${paymentId}`
    );
  }

  downloadInvoice(paymentId: string): Observable<unknown> {
    return this._httpClient.get(
      `${this._apiConstantsService.paymentsUrl}/${paymentId}/download-invoice`,
      {
        responseType: 'arraybuffer',
        observe: 'response'
      }
    );
  }

  checkout(params: PaymentCheckoutParams): Observable<PaymentCheckout> {
    return this._httpClient.post<PaymentCheckout>(
      `${this._apiConstantsService.paymentCheckoutUrl}`,
      params
    );
  }
}
